import { SlotGameBody, SlotGameResponse } from '@/types'

import { api } from '../..'

export async function startSlotGame({
  demo,
  ...rest
}: SlotGameBody): Promise<SlotGameResponse> {
  const { data } = await api.post<SlotGameResponse>(
    demo ? '/slots/demo' : '/slots',
    rest
  )

  return data
}
